import { useState, useEffect, useCallback } from 'react';
import { playbookApi } from '../api/playbookApi';
import type { TransitionLogEntry } from '../types/playbook.types';

export function usePlaybookTimeline(instanceId: string | null) {
  const [logs, setLogs] = useState<TransitionLogEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!instanceId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await playbookApi.getTransitionLog(instanceId);
      const data = res as any;
      setLogs(data.logs || []);
    } catch (err) {
      console.error('[usePlaybookTimeline] Failed to load timeline:', err);
      setError(err instanceof Error ? err.message : 'Failed to load timeline');
    } finally {
      setLoading(false);
    }
  }, [instanceId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { logs, loading, error, refresh };
}
